import { FilterAutocomplete } from '../baseInputTypes/FilterAutocomplete'

type Props = {}
export const AffCode = (props: Props) => {
  return (
    <FilterAutocomplete
      multiple={false}
      label="Aff Code"
      fieldName={'affiliationCodes'}
      fieldPath={'mediaDetails.affiliationCode'}
    />
  )
}
